// extracted by mini-css-extract-plugin
export default {"Hamburger":"Icons_Hamburger__vzC9X"};